<template>
    <modal-helper v-show="isVisible" @close="close" title="Missing Attachments">
        <template v-slot:body>
            <section class="missing-attachments-container">
                 <template v-if="missingAttachmentResponse">
                    <p class="missing-attachments-text">Could not find {{missingAttachmentResponse.missingAttachments.length}} attachments.</p>
                 </template>
                <table-results-helper>
                    <template v-slot:table>
                        <table class="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th scope="col">Filename</th>
                                    <th class="right-aligned" scope="col">Case ID</th>
                                    <th class="right-aligned" scope="col">Note ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="missingAttachmentResponse">
                                    <tr v-for="missingAttachment in missingAttachmentResponse.missingAttachments"
                                        :key="missingAttachment.fileId">
                                        <td>{{ missingAttachment.filename }}</td>
                                        <td class="right-aligned">{{ missingAttachment.caseId }}</td>
                                        <td class="right-aligned">{{ missingAttachment.noteId }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </template>
                </table-results-helper>
            </section>
        </template>
        <template v-slot:footer>
            <button class="btn btn-outline-danger cancel-button" @click="close">Cancel</button>
            <button
                class="btn btn-primary ignore-attachments-button"
                @click="showCaseSummary">
                Continue without attachments
            </button>
        </template>
    </modal-helper>
</template>

<script>
import ModalHelper from '../components/helpers/ModalHelper.vue';
import TableResultsHelper from './helpers/TableResultsHelper.vue';

export default {
    name: 'MissingAttachmentsModal',
    components: {
        'table-results-helper': TableResultsHelper,
        'modal-helper': ModalHelper,
    },
    props: ['missingAttachmentResponse', 'isVisible'],
    methods: {
        showCaseSummary() {
            this.$emit('showCaseSummary');
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss" scoped>
  .missing-attachments-container {
      display: flex;
      flex-direction: column;
      margin-bottom: var(--global-gutter-size);
      width: 100%;
      .missing-attachments-text {
          color: red;
      }
  }
  .ignore-attachments-button,
  .cancel-button {
      flex: 1;
  }  
  .right-aligned {
       text-align: right;
  }
</style>
